import {
  ApiActiveCustomersTrendResponse,
  ApiDimension,
} from "@incendium/api";
import { analyticsService } from "Apis";

export default async function getActiveCustomersTrend(
  projectId: number,
  from?: Date,
  to?: Date,
  lastNDays?: number,
  granularity: ApiDimension = ApiDimension.DIMENSION_SESSION_START_BY_DAY,
  windowDays = 90,
): Promise<ApiActiveCustomersTrendResponse> {
  return analyticsService.analyticsServiceGetActiveCustomersTrend({
    projectId,
    payload: {
      from,
      to,
      lastNDays,
      granularity,
      windowDays,
    },
  });
}
